import React, {useState, useEffect} from 'react';
import {useDispatch} from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    Position,
    ColumnChooser,
    Paging,
    Pager,
    Form,
    ToolbarItem,
    Editing, HeaderFilter,
    Selection,     Scrolling
    , Export, Summary, TotalItem
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import {Button} from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store'; 
import {Popup} from 'devextreme-react/popup';
import { SelectBox } from 'devextreme-react/select-box'; 
import {showToast,parseDate} from "../../utils/Utils";
import {ToastType} from "../../constants/Constants"; 
import TesvikRapor from '../tesvikrapor/TesvikRapor';
import './TesvikRaporIslemleri.scss';

const TesvikRaporIslemleri = (props) => {

    const dispatch = useDispatch();



    const listeBasligi = "Teşvik Detayları";
    const [domainDataValue, setDomainDataValue] = useState({});
    const [domainDataSource, setDomainDataSource] = useState([]);
    const [store, setStore] = useState(null);
    const [donemDataValue, setDonemDataValue] = useState({});
    const [donemDataSource, setDonemDataSource] = useState([]);
    const [raporData, setRaporData] = useState({ popupState: false, data: {} });
    // const [tesvikFarkRaporData, setTesvikFarkRaporData] = useState({ popupState: false, data: {} });

    useEffect(() => {
        domainListYukle();
        donemListYukle();
       yenile();
    }, [])

    useEffect(() => {
        yenile();
    }, [domainDataValue])
    useEffect(() => {
        yenile();
    }, [donemDataValue])

    const domainListYukle = () => {

        const request = new Request("/userDomain/getUserDomainList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    let dommainList = [];
                    response.data.data.map(sd => {
                        if(sd.sicilNo != null && sd.sicilNo != ""){
                            dommainList.push(sd);
                        }
                    });
                    setDomainDataSource(dommainList);
                } else {
                    return []

                }
            });
    }

    const donemListYukle = () => {

        const request = new Request("/donem/getKayitList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    response.data.data.map(d => {
                        d.tarih = parseDate(d.tarih);
                    });
                    let datas = [];
                    let simdi = new Date();
                    response.data.data.map(d => {
                        if(d.tarih.getTime() < simdi.getTime() ){
                            datas.push(d);
                        }
                    });
                    datas.sort((a,b) =>
                        a.tarih.getTime() - b.tarih.getTime()
                    ).reverse();


                    setDonemDataSource(datas);
                } else {
                    return []
                }
            });
    }

    let dataGrid = null;

     
    const getStore = () => {
        let domainId = 0;
        let donemId =0;
        if (domainDataValue.id != null) {
           // showToast('Domain seçiniz', ToastType.ERROR, 500);
            domainId =domainDataValue.id;
        }
         if (donemDataValue.id != null) {
           // showToast('Dönem Seçiniz', ToastType.ERROR, 500);
           donemId =donemDataValue.id;
        }

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                 //
                 let url = "/tesvikRaporIslemleri/getKayitList/"+ domainId +"/" + donemId ;
                 if(props.data != null && props.data.domainId != null && props.data.donemId != null){
                    url = "/tesvikRaporIslemleri/getKayitList/"+ props.data.domainId +"/" + props.data.donemId ;
                 }
                const request = new Request(url , "GET");

                return request.run()
                .then(response => {
                    if (response.data) {

                        response.data.data.map(d => {
                            d.hesapDonemTar = parseDate(d.hesapDonemTar);
                            d.donemBas = parseDate(d.donemBas);
                            d.donemBit = parseDate(d.donemBit);
                            d.iseBaslamaTar = parseDate(d.iseBaslamaTar);
                            d.istenAyrilisTar = parseDate(d.istenAyrilisTar);
                        });
                        return {
                            data: response.data.data,
                            totalCount: response.data.total,
                            summary: 0,
                            groupCount: 0
                        };
                    } else {
                        return []

                    }
                });
            }
        });
    }

    // let store = getStore();

    const yenile = () => {
        setStore(getStore());
    }
    function selectionDomainChanged({ selectedItem }) {
        setDomainDataValue(selectedItem);
    }
    function selectionDonemChanged({ selectedItem }) {
        setDonemDataValue(selectedItem);
    }
    const raporOlustur = () => {

        let domainId =null;
        let donemId =null;

        if(props.data != null && props.data.domainId != null && props.data.donemId != null){
            domainId =  props.data.domainId;
            donemId = props.data.donemId;
        }else{
            if (domainDataValue.id != null) {
                domainId =  domainDataValue.id;
            }
            if (donemDataValue.id != null) {
                donemId = donemDataValue.id;
            }
        }



        if (domainId == null) {
            showToast('Domain seçiniz', ToastType.ERROR, 500);
            return;
        }
        if (donemId == null) {
            showToast('Dönem seçiniz', ToastType.ERROR, 500);
            return;
        }

        setRaporData({
            popupState: true,
            data: { domainId: domainId,donemId:donemId }
        });
    }
    // const raporFarkOlustur = () => {

    //     if (domainDataValue.id == null) {
    //         showToast('Domain seçiniz', ToastType.ERROR, 500);
    //         return;
    //     }
    //     // if (donemDataValue.id == null) {
    //     //     showToast('Dönem seçiniz', ToastType.ERROR, 500);
    //     //     return;
    //     // }

    //     setTesvikFarkRaporData({
    //         popupState: true,
    //         data: { domainId: domainDataValue.id }
    //     });
    // }



    function hideTesvikRaporPopup() {
        setRaporData({ popupState: false, data: {} })
    }

    // function hideTesvikRaporFarkPopup() {
    //     setTesvikFarkRaporData({ popupState: false, data: {} })
    // }
    function siraRender(data) {
        return (data.rowIndex +1);// <b>{(data.rowIndex +1)}</b> ;
    }

    function kanunStyle(data) {

        if( data.row.data.beyanKanunNo != data.row.data.kanunNo){
         //return   <div style={{backgroundColor:  '#5C95C5'}}>{data.value}</div>
         //return  <div style={{backgroundColor:  '#5C95C5'}}> <b>{data.value}</b></div>
        //  if(!data.component.isRowSelected(data.rowIndex)){
            //  data.cellElement.style.backgroundColor ='#5C95C5'
             return  <div style={{backgroundColor:  '#F6BB42', margin:0}}> <b>{data.value}</b></div>
         // }

        }
        return data.value;
    }


    return (
        <div >
            {
                props.data ? null : <h2 className={'dx-icon-product'}>{listeBasligi}</h2>
            }
            {
                props.data ? null :
                    <div className="dx-field">
                        <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                            <SelectBox
                                dataSource={domainDataSource}
                                displayExpr="name"
                                searchEnabled={true}
                                searchMode={'contains'}
                                searchExpr={'name'}
                                searchTimeout={200}
                                minSearchLength={0}
                                width="350"
                                onSelectionChanged={selectionDomainChanged}
                            //showDataBeforeSearch={showDataBeforeSearchOption}
                            />
                            <SelectBox
                                dataSource={donemDataSource}
                                displayExpr="donem"
                                searchEnabled={true}
                                searchMode={'contains'}
                                placeholder="Dönem Seçiniz..."
                                searchExpr={'donem'}
                                searchTimeout={200}
                                minSearchLength={0}
                                width="350"
                                onSelectionChanged={selectionDonemChanged}
                            //showDataBeforeSearch={showDataBeforeSearchOption}
                            />

                            {/* <Button icon="search" width={175} text="Yenile" type={'success'} style={{ fontSize: "15px" }} onClick={yenile}></Button>
                            <Button icon="filter" width={175} text="Rapor" type={'success'} style={{ fontSize: "15px" }} onClick={raporOlustur}></Button> */}
                            {/* <Button icon="filter" width={120} text="Rapor Fark" type={'success'} style={{fontSize: "15px"}} onClick={raporFarkOlustur}></Button> */}
                        </div>
                    </div>
            }
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    <Button icon="search" width={175} text="Yenile" type={'success'} style={{ fontSize: "15px" }} onClick={yenile}></Button>
                    <Button icon="filter" width={175} text="Rapor" type={'success'} style={{ fontSize: "15px" }} onClick={raporOlustur}></Button>
                    {/* <Button icon="filter" width={120} text="Rapor Fark" type={'success'} style={{fontSize: "15px"}} onClick={raporFarkOlustur}></Button> */}
                </div>
            </div>

            <DataGrid
                className= { props.gridClassName ? props.gridClassName : "tesvikRaporIslemleriListesiGrid"}  
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                selection={{ mode: 'single', deferred: true }}
            //remoteOperations={true}
            >
                <FilterRow visible={true} />
                <Export enabled={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />

                {/* <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20, 50, 100, 200]} showInfo={true}  visible={true} />
                <Paging defaultPageSize={10} /> */}

                <Column width={30} caption={'Sıra'} dataType="number" visible={true} cellRender={siraRender} />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'tesvikDetayId'} width={90} caption={'tesvikDetayId'} dataType="number" visible={false} />
                <Column dataField={'personelId'} width={90} caption={'personelId'} dataType="number" visible={false} />


                <Column dataField={'personelTcKimlik'} width={90} caption={'Tck No'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'personelAdi'} minWidth={90} width={90} caption={'Adı'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'personelSoyadi'} minWidth={90} width={90} caption={'Soyadı'} dataType="string" mappingType="String" visible={true} />

                <Column dataField="iseBaslamaTar" width={70} caption={'İşe baş. tar.'} dataType="date" format="dd.MM.yyyy" visible={false} />
                <Column dataField="istenAyrilisTar" width={70} caption={'İşten Ayrılış tar.'} dataType="date" format="dd.MM.yyyy" visible={false} />
                <Column dataField={'belgeTuru'} width={40} caption={'Belge Çeşidi'} dataType="String" visible={true} />
                <Column dataField={'beyanKanunNo'} width={70} caption={'Beyan Kanun No'} dataType="String" visible={true} cellRender={kanunStyle} />
                <Column dataField="primDestegi" width={70} caption={'Pirim Desteği'} dataType="number" width={130} visible={true} />
                <Column dataField={'meslekAdi'} minWidth={50} width={50} caption={'Meslek Adı'} dataType="string" mappingType="String" visible={false} />
                <Column dataField={'meslekKodu'} minWidth={50} width={70} caption={'Meslek Kodu'} dataType="string" mappingType="String" visible={false} />

                <Column dataField="hesapDonemTar" width={70} caption={'Hesap-Dönem'} dataType="date" format="yyyy/MM" visible={false} />

                <Column dataField="kanunNo" width={70} caption={'Önerilen Kanun No'} dataType="string" visible={true} cellRender={kanunStyle} />
                <Column dataField="donemBas" width={70} caption={'Başlangıç'} dataType="date" format="yyyy/MM" visible={false} />
                <Column dataField="donemBit" width={70} caption={'Bitiş'} dataType="date" format="yyyy/MM" visible={false} />

                <Column dataField="primDestegiYuzde5Haric" width={70} caption={'Pirim Desteği'} dataType="number" width={130} visible={true} />
                <Column dataField="tesvikSgkOnay" width={30} caption={'Onay'} dataType="boolean" visible={true} />


                <Column dataField={'ucret'} width={60} caption={'Prime Esas Kazanç (ikramiye ve ücret toplamı)'} dataType="number" visible={true} />
                <Column dataField={'ikramiye'} width={60} caption={'ikramiye'} dataType="number" visible={true} />
                
                <Column dataField={'gun'} width={40} caption={'Gün'} dataType="number" visible={true} />
                <Column dataField={'ortalamaGunSayisi'} width={40} caption={'Ortalama Gün (7252)'} dataType="Number" visible={false} />
                <Column dataField={'kanunsuzBildirlecekGunSayisi'} width={40} caption={'Kanunsuz Bilgrilecek Gün'} dataType="Number" visible={false} />



                <Column dataField="ilaveOlunacakSayi" width={70} caption={'Ortalama'} dataType="string" visible={true} />
                <Column dataField={'calisanSayi6111'} width={60} caption={'Ç.Sayı - 6111'} dataType="number" visible={true} />
                <Column dataField={'calisanSayi7103'} width={60} caption={'Ç.Sayı - 7103'} dataType="number" visible={true} />
                 
                <Summary>
                    <TotalItem
                        column="primDestegi"
                        summaryType="sum" 
                        valueFormat="currency" 
                        displayFormat="Toplam:{0} TL" />
                    <TotalItem
                        column="primDestegiYuzde5Haric"
                        summaryType="sum"
                        valueFormat="currency" 
                        displayFormat="Toplam:{0} TL" />
                </Summary>

            </DataGrid>

            <Popup
                visible={raporData.popupState}
                onHiding={hideTesvikRaporPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title= {domainDataValue.name + "   Teşvik Rapor"}
                width={900}
                height={600}
            >
                <div>
                    {raporData.popupState ? <TesvikRapor data={raporData.data} hide={hideTesvikRaporPopup} gridClassName="tesvikRaporPopupGrid"  /> : null}
                    <Button
                        width={900}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideTesvikRaporPopup}
                    />
                </div>
            </Popup>
 

        </div>
    )
}

export default TesvikRaporIslemleri;
